<template>
  <div class="how_to_play">
    <h1>What is Get24?</h1>
    <div class="box box1">
      <div class="top">
        This website is a GACHA (Completely random lottery system) site<br>
        where you can get popular Japanese products.<br>
        For example, trading cards, games, figures, cosmetics, etc.
      </div>
      <div class="center">
        You can get your favorite products<br>with excitement and thrill
      </div>
      <div class="bottom">
        <img src="/img/how_to_play/1.png" alt="">
      </div>
    </div>
    <div class="welcome">
      <img src="/img/how_to_play/2.png" alt="" class="left">
      <div class="welcome_txt">
          <!-- <svg class="svg-text" viewBox="0 0 1000 100" width="1000" height="100">
              <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                      <stop offset="0%" style="stop-color:#f5d76e;stop-opacity:1" />
                      <stop offset="100%" style="stop-color:#c29d3e;stop-opacity:1" />
                  </linearGradient>
              </defs>
              <text x="50%" y="75" font-size="100" text-anchor="middle" fill="url(#gradient)">Welcome to get24</text>
          </svg> -->
        <h2>Welcome to get24</h2>
        <div>Since Dec.2022</div>
        <div>World's first Web GACHA</div>
      </div>
      <img src="/img/how_to_play/3.png" alt="" class="right">
    </div>
    <InstructionsView />
    <div class="welcome about">
      <div class="welcome_txt">
        <!-- <svg class="svg-text" viewBox="0 0 1000 100" width="1000" height="100">
          <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" style="stop-color:#f5d76e;stop-opacity:1" />
                  <stop offset="100%" style="stop-color:#c29d3e;stop-opacity:1" />
              </linearGradient>
          </defs>
          <text x="50%" y="75" font-size="100" text-anchor="middle" fill="url(#gradient)">What's great about this site</text>
        </svg> -->
        <h2>What's great about this site</h2>
      </div>
    </div>
    <HowtoAboutView />
  </div>
</template>

<script>
import InstructionsView from '@/components/molecules/InstructionsView.vue';
import HowtoAboutView from '@/components/molecules/HowtoAboutView.vue';

export default {
  name: 'HowToPlay',
  components: {
    InstructionsView,
    HowtoAboutView,
  },
};
</script>

<style lang="scss" scoped>
.how_to_play {
  margin: 0 auto 50px auto;
  max-width: 800px;
  font-family: 'Arial Black', 'Helvetica Bold', sans-serif;
  h1 {
    text-align: center;
    color: #00ffff;
    font-size: 48px;
    text-shadow: 0 0 10px #000, 0 0 20px #000, 0 0 30px #000;
}
  .box {
    background: linear-gradient(to bottom, #146bee, #0094e3);
    margin: 5px 10px 0;
    padding: 15px 15px 5px 15px;
  }
  .box1 {
    color: $white;
    font-size: 18px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .top {
      margin: auto;
    }
    .center {
      text-align: center;
      font-size: 32px;
      color: #ffff4d;
    }
    .bottom {
      text-align: center;
      img {
        width: 100%;
      }
    }
  }
  .welcome {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 20px;
    .welcome_txt {
      font-size: 30px;
      text-align: center;
      color: $white;
      h2 {
        // background: linear-gradient(to bottom, #f5d76e, #c29d3e);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
        font-size: 48px;
        text-align: center;
        color: #e7c761;
        text-shadow: 0 0 10px #000, 0 0 20px #000, 0 0 30px #000;
      }
      .svg-text {
        text {
          font-size: 48px;
          text-shadow: 0 0 10px #000, 0 0 20px #000, 0 0 30px #000;
        }
      }
    }
    img {
      width: 18%;
      position: absolute;
    }
    .left {
      bottom: -15%;
      left: 5%;
    }
    .right {
      bottom: -15%;
      right: 5%;
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .how_to_play {
    h1 {
      font-size: 36px;
    }
    .box1 {
      font-size: 12px;
      .center {
        font-size: 18px;
      }
    }
    .welcome {
      .welcome_txt {
        font-size: 18px;
        h2 {
          font-size: 30px;
        }
        // .svg-text {
        //   text {
        //     font-size: 30px;
        //   }
        // }
      }
      .left {
        bottom: -6%;
        width: 17%;
        left: 0;
      }
      .right {
        bottom: -6%;
        width: 17%;
        right: 0;
      }
    }
    .about {
      .welcome_txt {
        h2 {
          font-size: 24px;
        }
        // .svg-text {
        //   text {
        //     font-size: 24px;
        //   }
        // }
      }
    }
  }
}
</style>
